import logo from './logo.svg';
import './App.css';
import Calendar from './Calendar';
import Dashboard from "./dashboard/Dashboard"
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Deregister from './Deregister';

function App() {

  return (
    <Router>
    
      <Switch>
        <Route path="/:id/:day/:date/:time" component={Deregister} />  
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/" component={Calendar} />
        
      </Switch>

    </Router>
  );
}

export default App;
